import { FC, ReactNode } from 'react';
import { TOKENS } from './tokens';

type Props = {
  children: ReactNode;
  as?: 'div' | 'span' | 'label';
};

// Small uppercase label used as a section header inside cards. Sets a
// consistent tone across the redesigned UI ("STATUS DA FROTA",
// "TIPOS DE ALARME", etc.).
export const SectionLabel: FC<Props> = ({ children, as = 'div' }) => {
  const Tag = as as any;
  const t = TOKENS.typography.label;
  return (
    <Tag
      style={{
        fontSize: t.size,
        fontWeight: t.weight,
        textTransform: t.transform,
        letterSpacing: t.tracking,
        color: TOKENS.color.muted,
      }}
    >
      {children}
    </Tag>
  );
};
